
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/react-stack",
      function () {
        return require("private-next-pages/system/react-stack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/react-stack"])
      });
    }
  